import { defineAsyncComponent } from 'vue'
export default {
  "checkout-legacy": defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/checkout-legacy.vue").then(m => m.default || m)),
  checkout: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/checkout.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/default.vue").then(m => m.default || m)),
  success: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/success.vue").then(m => m.default || m))
}